import AdminDashboard from '../pages/admin/Dashboard';
import Dashboard1 from '../pages/admin/Dashboard1';
import Dashboard2 from '../pages/admin/Dashboard2';
import Dashboard3 from '../pages/admin/Dashboard3';
import Branch from '../pages/admin/Branch';
import Student from '../pages/admin/Student';
import StudentPerformance from '../pages/admin/StudentPerformance'; // ✅ Import your new page
import StudentReports from '../pages/admin/StudentReports'; 
import Fees from '../pages/admin/Fees';
import UserAccounts from "../pages/admin/UserAccounts";
import PaidFees from "../pages/admin/PaidFees";

import Coach from '../pages/admin/Coach';
import Principle from '../pages/admin/Principle';
import Book from '../pages/admin/Book';
import Session from '../pages/admin/Session';
import Attendance from '../pages/admin/Attendance';
import ApplicationForm from "../pages/admin/ApplicationForm";

// Books & Library Components
import BooksList from "../pages/admin/Books";
import BookChapters from "../pages/admin/BookChapters";

// Session
import SessionMaster from "../pages/admin/SessionMaster";
import SessionInfo from "../pages/admin/SessionInfo";

// Homework
import HomeworkList from "../pages/admin/HomeworkList";
import HomeworkSubmissions from "../pages/admin/HomeworkSubmissions";

// TOURNAMENT PARTICIPANTS PAGE
import Tournaments from "../pages/admin/Tournaments";
import TournamentParticipants from "../pages/admin/TournamentParticipants";
import TournamentExpenses from "../pages/admin/TournamentExpenses";
import ProfitLoss from "../pages/admin/ProfitLoss";

const adminRoutes = [
  { path: 'dashboard', element: <AdminDashboard /> },
  { path: 'dashboard1', element: <Dashboard1 /> },
  { path: 'dashboard2', element: <Dashboard2 /> },
  { path: 'dashboard3', element: <Dashboard3 /> },
  { path: 'branch', element: <Branch /> },
  { path: 'student', element: <Student /> },
  // ✅ New Route for Performance Tracking
  { 
    path: 'student/tournament-performance', 
    element: <StudentPerformance /> 
  },
  { path: 'student-reports', element: <StudentReports /> }, // ✅ 2. Added Student Reports Route
  { path: 'collect-fee', element: <Fees /> },
  { path: 'user-accounts', element: <UserAccounts /> },
  { path: 'fee-receipts', element: <PaidFees /> },

  { path: 'coaches', element: <Coach /> },
  { path: 'principle', element: <Principle /> },
  { path: 'book', element: <Book /> },
  { path: 'session', element: <Session /> },
  { path: 'Attendance', element: <Attendance /> },
  { path: 'application-form', element: <ApplicationForm /> },

  // ================= Books & Library =================
  { 
    path: 'books/list', 
    element: <BooksList /> 
  },
  { 
    path: 'books/chapters', 
    element: <BookChapters /> 
  },

  { 
    path: 'tournaments/list', 
    element: <Tournaments /> 
  },

  // ================= Session =================
  { 
    path: 'session/session-master', 
    element: <SessionMaster /> 
  },
  { 
    path: 'session/session-log', 
    element: <SessionInfo /> 
  },

  // ================= Homework =================
  { 
    path: 'homework/list', 
    element: <HomeworkList /> 
  },
  { 
    path: 'homework/submissions', 
    element: <HomeworkSubmissions /> 
  },

  // ================= TOURNAMENT PARTICIPANTS =================
  { 
    path: 'tournaments/participants', 
    element: <TournamentParticipants /> 
  },
  { 
    path: 'tournaments/expense', 
    element: <TournamentExpenses /> 
  },
  { 
    path: 'tournaments/profit-loss', 
    element: <ProfitLoss /> 
  },
];

export default adminRoutes;